var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMiniWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.65 214.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f25c7c;}.cls-3{fill:#10a6fa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.18,40.85a9.81,9.81,0,0,1,3.4.61A115.7,115.7,0,0,1,47.06,4.28a3,3,0,0,0-5.31-2.63c-.39.78-8.2,16.81-10.11,39.54A9.67,9.67,0,0,1,34.18,40.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,50.66a9.81,9.81,0,0,1-1.42,5.07c4.24.75,8.75,1.47,13.51,2.1l.4,0a3,3,0,0,0,.38-5.9c-4.54-.61-8.83-1.29-12.91-2C44,50.18,44,50.42,44,50.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.91,45.3a208.47,208.47,0,0,0,22.55,6.64,10.71,10.71,0,0,1-.09-1.28,9.72,9.72,0,0,1,1.14-4.59A208.11,208.11,0,0,1,4,39.76,3,3,0,1,0,1.91,45.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.49,100.15a3,3,0,0,0-3.76-1.85c-6.21,2.1-20.17,5.91-38.56,9.13-5.09-13.53-9.82-28.37-10.71-50.85,31.08-4.5,50.95-11.17,51.18-11.25a3,3,0,1,0-1.91-5.61c-.22.08-19.34,6.48-49.4,10.89a117.17,117.17,0,0,1,9.91-46.33,3,3,0,1,0-5.31-2.63A120.66,120.66,0,0,0,151.4,51.43q-5.15.68-10.65,1.25a387.32,387.32,0,0,1-43.45,2c0-.41,0-.8,0-1.22a117.17,117.17,0,0,1,9.89-49.19,3,3,0,1,0-5.31-2.63,120.92,120.92,0,0,0-10.5,52l0,1c-5.71-.15-11.39-.42-17-.84-1.56-.11-3.13-.24-4.68-.38a3,3,0,1,0-.53,5.91c1.58.14,3.19.27,4.78.39q8.79.63,17.7.85a148.6,148.6,0,0,0,7.27,38.7c-.47.25-.93.51-1.37.8A19.32,19.32,0,0,0,89,113.09c-4.92-.16-9.81-.4-14.67-.76-9.22-.67-17.83-1.75-25.64-3-5.1-13.38-10-27.76-11.26-49.41a9.59,9.59,0,0,1-5.93.19c1.18,20.83,5.6,35.1,10.42,48.05C18.85,103.89,4.22,98.41,4,98.33a3,3,0,0,0-2.11,5.54c.9.34,17.05,6.41,42.49,10.77l.19.51c4.63,12,9,23.38,10.82,39a111.72,111.72,0,0,1,.7,14.8C25,164.78,4.26,157,4,156.91a3,3,0,1,0-2.11,5.54c1,.39,22,8.26,54,12.51a135.71,135.71,0,0,1-7,35.35,3,3,0,0,0,5.53,2.12,136.68,136.68,0,0,0,7.43-36.74q5.85.66,12.13,1.13,13.47,1,27.22,1c4.86,0,9.74-.12,14.63-.31a135,135,0,0,1-6.85,32.82,3,3,0,0,0,1.71,3.83,3,3,0,0,0,1.06.19,3,3,0,0,0,2.76-1.9,136.88,136.88,0,0,0,7.32-35.18q9.77-.52,19.59-1.52a3,3,0,0,0-.61-5.9q-9.34,1-18.66,1.46a121.41,121.41,0,0,0-.7-17.78,125.59,125.59,0,0,0-4.1-20.18c.49-.27,1-.51,1.47-.82a19.27,19.27,0,0,0,8.38-12.27c.13-.64.23-1.29.3-1.94,4.64-.31,9.28-.67,13.92-1.15,8.12-.84,15.84-1.9,23-3.06.14.35.28.7.41,1.06,4.63,12,9,23.38,10.82,39,.41,3.49.62,6.94.69,10.3-6.61,1.32-14.14,2.62-22.44,3.76a3,3,0,0,0,.39,5.9,2.83,2.83,0,0,0,.41,0c8-1.09,15.21-2.32,21.61-3.57A136.07,136.07,0,0,1,169,210.31a3,3,0,0,0,1.7,3.83,3,3,0,0,0,1.06.19,3,3,0,0,0,2.77-1.9,138.33,138.33,0,0,0,7.69-43.08,255.57,255.57,0,0,0,26.41-6.86,3,3,0,0,0-1.91-5.62,247.68,247.68,0,0,1-24.55,6.41c-.1-3.19-.32-6.45-.7-9.77-1.91-16.38-6.61-28.62-11.16-40.44,18.23-3.26,32.09-7,38.32-9.16A3,3,0,0,0,210.49,100.15Zm-94.36,71.43a374.42,374.42,0,0,1-41.78-.67c-4.24-.31-8.34-.71-12.31-1.17a118.83,118.83,0,0,0-.74-16.23c-1.77-15.16-5.93-26.77-10.14-37.79,7,1,14.64,1.93,22.76,2.52,5,.37,10,.62,15,.78a19.29,19.29,0,0,0,15.21,16.24,19.61,19.61,0,0,0,4,.42,18.86,18.86,0,0,0,3.52-.37,117.14,117.14,0,0,1,3.8,18.89A113,113,0,0,1,116.13,171.58Zm5.26-52.89c0,.12,0,.23,0,.34a13.43,13.43,0,0,1-5.82,8.52h0v0h0a13.31,13.31,0,0,1-5.56,2.06v0c-.2,0-.41,0-.61.06l-.16,0a13.38,13.38,0,0,1-12.33-6,12.88,12.88,0,0,1-1.24-2.42,0,0,0,0,1,0,0,11.35,11.35,0,0,1-.38-1.12c0-.13-.08-.27-.11-.4s-.1-.33-.13-.5h0a13.53,13.53,0,0,1,0-5.94h0c0-.21.12-.42.17-.63s.08-.29.13-.43a9.25,9.25,0,0,1,.32-.88l.11-.3c.16-.37.33-.74.52-1.09a.08.08,0,0,0,0,0,13.43,13.43,0,0,1,4.47-4.88l.09,0v0a13.3,13.3,0,0,1,5.57-2v0l.41,0,.5,0c.26,0,.52,0,.78,0a13.22,13.22,0,0,1,2.79.29,13.36,13.36,0,0,1,8.52,5.82c.12.17.2.37.31.55s.35.62.51.94l.33.72c.2.49.38,1,.53,1.49,0,.06,0,.11.05.16h0a13.46,13.46,0,0,1,.24,6Zm19.36-7.44c-4.53.47-9.07.83-13.59,1.14a19.47,19.47,0,0,0-2.78-6.75,19.44,19.44,0,0,0-19.91-8.44,143.66,143.66,0,0,1-6.9-36.58l3.57,0a391.92,391.92,0,0,0,40.22-2.08q5.26-.54,10.2-1.19c.95,22.48,5.59,37.47,10.66,51.05C155.51,109.5,148.31,110.48,140.75,111.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.14,
    cy: 54.3,
    r: 9.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.14,
    cy: 54.3,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.51,
    cy: 111.46,
    r: 9.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.51,
    cy: 111.46,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 94.16,
    cy: 57.69,
    r: 9.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.23,100.66a9.82,9.82,0,1,0,9.81,9.81A9.82,9.82,0,0,0,166.23,100.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.07,
    cy: 50.66,
    r: 9.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.07,
    cy: 50.66,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 58.53,
    cy: 172.1,
    r: 9.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 58.53,
    cy: 172.1,
    r: 3.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 179.04,
    cy: 166.71,
    r: 9.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 118.67,
    cy: 174.84,
    r: 9.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 118.67,
    cy: 174.84,
    r: 3.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.63,125.91a14.46,14.46,0,1,1,14.45-14.45A14.47,14.47,0,0,1,46.63,125.91Zm0-23a8.53,8.53,0,1,0,8.53,8.53A8.53,8.53,0,0,0,46.63,102.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.18,65.12A14.46,14.46,0,1,1,48.64,50.66,14.47,14.47,0,0,1,34.18,65.12Zm0-23a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,34.18,42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.27,72.14a14.46,14.46,0,1,1,14.46-14.45A14.46,14.46,0,0,1,94.27,72.14Zm0-23a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,94.27,49.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.25,68.75A14.46,14.46,0,1,1,168.7,54.3,14.47,14.47,0,0,1,154.25,68.75Zm0-23a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,154.25,45.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.34,124.93a14.46,14.46,0,1,1,14.46-14.46A14.47,14.47,0,0,1,166.34,124.93Zm0-23a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,166.34,101.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.15,181.17a14.46,14.46,0,1,1,14.46-14.46A14.47,14.47,0,0,1,179.15,181.17Zm0-23a8.53,8.53,0,1,0,8.53,8.52A8.54,8.54,0,0,0,179.15,158.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.79,189.3a14.46,14.46,0,1,1,14.45-14.46A14.47,14.47,0,0,1,118.79,189.3Zm0-23a8.53,8.53,0,1,0,8.52,8.53A8.54,8.54,0,0,0,118.79,166.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.65,186.56A14.46,14.46,0,1,1,73.1,172.1,14.48,14.48,0,0,1,58.65,186.56Zm0-23a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,58.65,163.57Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniWhite);
export default __webpack_public_path__ + "static/media/logo-mini-white.a52648cbde6974d878f30f1bcd195352.svg";
export { ForwardRef as ReactComponent };